<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {pad0} from "../../lib/lib";

    export let id = '';
    export let time = null;
    export let cssClass = '';

    let inputTime = null;
    let oldTime = null;
    let seconds = null;

    const dispatch = createEventDispatcher();

    const onFocus = () => {
        if (inputTime) {
            inputTime = inputTime.replaceAll(":", "");
        }
    }

    const onFocusOut = () => {
        setTheTime();
    }

    const setTheTime = () => {
        let hour;
        let minutes;
        if (inputTime) {
            if (inputTime.length < 3) {
                hour = inputTime;
                minutes = 0;
            } else {
                minutes = inputTime.slice(-2);
                hour = inputTime.slice(0, inputTime.length - 2);
                if (hour && hour > 23) hour = 0;
                if (minutes && minutes > 59) minutes = 0;
            }

            inputTime = `${pad0(hour)}:${pad0(minutes)}`;
            time = inputTime + (seconds ? `:${seconds}` : '');
        } else {
            inputTime = null;
            time = null;
        }

        if (oldTime != time) {
            dispatch('change', time);
        }
    }

    const getSecondsFromTime = (timeStr) => {
        if (!timeStr) {
            return '';
        }
        let parts = timeStr.split(":");
        if (parts.length < 3) {
            return '';
        }
        return parts[2];
    }

    $: {
        if (time && seconds === null) {
            // initialize the seconds
            seconds = getSecondsFromTime(time);
        }
        if (time !== oldTime) {
            if (time) {
                let [h, m, s] = time.split(":");
                inputTime = `${h}:${m}`;
            }
            oldTime = time;
        }
    }
</script>

<input type="text" id="{ id }" class="form-control { cssClass }" bind:value="{ inputTime }"
       autocomplete="off"
       placeholder="hh:mm"
       maxlength="4"
       on:focus="{ onFocus }"
       on:focusout="{ onFocusOut }">
